var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_205",
    "data-name": "Group 205",
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.864,
    height: 159.096,
    viewBox: "0 0 198.864 159.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M24.868,159.1H54.693a24.9,24.9,0,0,0,24.868-24.868V104.4A24.888,24.888,0,0,0,54.693,79.536H24.868a24.915,24.915,0,0,0-4.984.509V59.652A39.809,39.809,0,0,1,59.652,19.884h9.942A9.942,9.942,0,0,0,69.594,0H59.652A59.706,59.706,0,0,0,0,59.652v74.577A24.888,24.888,0,0,0,24.868,159.1Z",
    transform: "translate(0 0)",
    fill: "#f2e6bc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M71.788,159.1h29.826a24.9,24.9,0,0,0,24.868-24.868V104.4a24.888,24.888,0,0,0-24.868-24.868H71.788a24.915,24.915,0,0,0-4.984.509V59.652a39.809,39.809,0,0,1,39.768-39.768h9.942a9.942,9.942,0,1,0,0-19.884h-9.942A59.706,59.706,0,0,0,46.92,59.652v74.577A24.888,24.888,0,0,0,71.788,159.1Z",
    transform: "translate(72.383 0)",
    fill: "#f2e6bc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.78f92b22bc5c51d13a9120c97ec94f5e.svg";
export { ForwardRef as ReactComponent };